import { Grid } from "@mui/material";
import MxFormL3SelectTrustField from "@rf-l3/form/MxFormL3SelectTrustField";
import MxFormL3InputField from "@rf-l3/form/MxFormL3InputField";
import MxFormL3TextDateField from "@rf-l3/form/MxFormL3DatePickerField";
import MxFormL4DocumentFileProperty from "@/src-refactor/modules/shared/components/refactor/components/l4/form/MxFormL4DocumentFileProperty";
import { useFormValidationsDocumentsMsgSlice } from "../../../../../../../store/slices/form-validations-documents-msg/FormValidationsDocumentsMsgSlice";
import MxTypography from "@rf-l1/MxTypography";
import useValidateExplicitField from "../../hooks/useValidateExplicitField";
import useShowValidationInfo from "@rf/property/module/components/modal/useShowValidationInfo";
import { IFileData } from "@rf-l1/file/helpers/create-file-data";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";
import { CValidationDocumentKeys } from "../../../../../../../util/model/documents-types";

const IsYes = () => {
  const {
    validationDocuments: { trust, trust_transferred_title }
  } = useFormValidationsDocumentsMsgSlice();
  const { validateField } = useValidateExplicitField();
  const { showNotification } = useShowValidationInfo();

  const handleOnClickOnExternalIndicators = (
    file: IFileData | null,
    ctx: any,
    itemCtx: any
  ) => {
    showNotification(itemCtx.msg, itemCtx.status);
  };

  return (
    <Grid container item xs={12} spacing={1}>
      <Grid
        container
        item
        xs={4}
        rowGap={2}
        justifyContent="center"
        alignSelf="flex-start"
      >
        <Grid item xs={12}>
          <MxFormL3SelectTrustField
            withreacthookform={1}
            name={CPropertyValidationDocumentKeys.trust_name_trustee}
            label="Nombre de fiduciaria"
          />
        </Grid>
        <Grid item xs={12}>
          <MxFormL3InputField
            withreacthookform={1}
            name={CPropertyValidationDocumentKeys.trust_name_official_trustee}
            label="Nombre de ejecutivo"
          />
        </Grid>
        <Grid item xs={12}>
          <MxFormL3InputField
            withreacthookform={1}
            name={CPropertyValidationDocumentKeys.trust_email_trustee}
            label="Correo de fiduciaria"
          />
        </Grid>
      </Grid>
      <Grid container item xs={3} rowGap={1}>
        <MxFormL4DocumentFileProperty
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.file_definitive_trustee}
          label="Fideicomiso definitivo"
          maxSize={3}
          minSize={0}
          disabled={trust.disabled}
          typeKey={CValidationDocumentKeys.Trust}
        />

        <MxFormL3TextDateField
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.date_file_definitive_trustee}
          label="Fecha de fideicomiso"
          disabled={trust.disabled}
        />
        <MxFormL3InputField
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.trust_rnc_trustee}
          label="RNC"
        />
      </Grid>
      <Grid item xs={3}>
        <MxFormL4DocumentFileProperty
          withreacthookform={1}
          name={CPropertyValidationDocumentKeys.file_title_transfer_trustee}
          label="Título transferido a fideicomiso"
          maxSize={3}
          minSize={0}
          disabled={trust_transferred_title.disabled}
          typeKey={CValidationDocumentKeys.TrustTransferredTitle}
        />
      </Grid>
    </Grid>
  );
};

export default IsYes;
